import error from '@assets/icons/error.svg';
import { Button, FModal, LoadingIndicator } from '@components';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ResgateParcialService } from '@services';
import { toast } from 'react-toastify';
import { isBefore, format } from 'date-fns';
import { StepsResgateSimulacao } from './Steps';
import { TermosResgateSimulacao } from './Terms';
import { FormSuccessResgateParcial } from './Success';

export const SolicitacaoFormularioResgateParcialPage = () => {
  const { matricula, plano, token } = useSelector((state) => state.user.data);
  const { nome } = useSelector((state) => state.user.dadosPessoais);
  const [viewTerms, setViewTerms] = useState(true);
  const [loading, setLoading] = useState(true);
  const [dadosPrevidenciarios, setDadosPrevidenciarios] = useState({});
  const [dadosEmprestimo, setDadosEmprestimo] = useState({});
  const [registroResgate, setRegistroResgate] = useState({});
  const [exibiSucesso, setExibiSucesso] = useState(false);

  const [erroModalIsOpen, setErroModalIsOpen] = useState(false);
  const [msgErro, setMsgErro] = useState('');
  const [msgTrava, setMsgTrava] = useState('');

  const obterDadosResgate = useCallback(async () => {
    const service = new ResgateParcialService();

    try {
      setViewTerms(true);
      const [
        dadosPrevidenciariosResponse,
        dadosEmprestimoResponse,
        historicoResgateResponse,
      ] = await Promise.all([
        service.ObterDadosPrevidenciariosResgate(matricula, plano),
        service.ObterDadosEmprestimoResgate(matricula),
        service.ObterHistoricoResgateParcial(matricula, plano),
      ]);

      setDadosPrevidenciarios(dadosPrevidenciariosResponse);
      setDadosEmprestimo(dadosEmprestimoResponse);

      if (
        historicoResgateResponse[0]?.Status === 'Em Análise' ||
        historicoResgateResponse[0]?.Status === 'Em Processamento'
      ) {
        setRegistroResgate(historicoResgateResponse[0]);
        setExibiSucesso(true);
      }

      // Validação de carência 60 meses
      if (
        isBefore(
          new Date(),
          new Date(dadosPrevidenciariosResponse.DataLiberacaoCarencia)
        )
      ) {
        setMsgTrava(
          `Ainda em período de carência. O resgate parcial poderá ser solicitado a partir de 60 meses contados da inscrição. Data prevista ${format(
            new Date(dadosPrevidenciariosResponse.DataLiberacaoCarencia),
            'dd/MM/yyyy'
          )}. `
        );
      }

      // Validação de carência 36 meses
      if (
        isBefore(
          new Date(),
          new Date(dadosPrevidenciariosResponse.DataLiberacaoIndividualCarencia)
        ) &&
        dadosPrevidenciariosResponse.DataLiberacaoIndividualCarencia
      ) {
        setMsgTrava(
          `Ainda em período de carência. O resgate parcial poderá ser solicitado a partir de 36 meses contados da efetivação da portabilidade. Data prevista ${format(
            new Date(
              dadosPrevidenciariosResponse.DataLiberacaoIndividualCarencia
            ),
            'dd/MM/yyyy'
          )}. `
        );
      }

      setLoading(false);
    } catch (e) {
      toast.error('Erro ao obter dados de resgate');
    }
  }, [matricula, plano]);

  useEffect(() => {
    obterDadosResgate();
  }, [obterDadosResgate, exibiSucesso]);

  return (
    <>
      {!loading ? (
        <div>
          {!msgTrava ? (
            <div>
              {exibiSucesso ? (
                <FormSuccessResgateParcial
                  registroResgate={registroResgate}
                  setExibiSucesso={setExibiSucesso}
                  dadosPrevidenciarios={dadosPrevidenciarios}
                  dadosEmprestimo={dadosEmprestimo}
                />
              ) : (
                <div>
                  {viewTerms ? (
                    <TermosResgateSimulacao setViewTerms={setViewTerms} />
                  ) : (
                    <StepsResgateSimulacao
                      setErroModalIsOpen={setErroModalIsOpen}
                      setMsgErro={setMsgErro}
                      setExibiSucesso={setExibiSucesso}
                      setViewTerms={setViewTerms}
                      dadosPrevidenciarios={dadosPrevidenciarios}
                      dadosEmprestimo={dadosEmprestimo}
                      dadosPessoais={{ matricula, plano, token, nome }}
                    />
                  )}
                </div>
              )}
            </div>
          ) : (
            <div className="card">
              <div className="card-body pb-0">
                <h3 className="ts-20 fw-bold mb-2">Atenção</h3>
                <p className="ts-14 text-muted mb-32">{msgTrava}</p>
              </div>
            </div>
          )}
        </div>
      ) : (
        <LoadingIndicator />
      )}

      {erroModalIsOpen && (
        <FModal
          isOpen={erroModalIsOpen}
          close={false}
          onClose={() => setErroModalIsOpen(false)}
        >
          <img className="mb-4" src={error} alt="Error Icon" />
          <h1 className="ts-20 fw-bold mb-1">{msgErro}</h1>
          <Button
            className="mt-32"
            onClick={() => {
              setErroModalIsOpen(false);
            }}
          >
            Ok
          </Button>
        </FModal>
      )}
    </>
  );
};
